module.exports = __webpack_public_path__ + "static/media/viewstock.8457cb7b.png";